/**
 * @file Re-exports the distribution schedule modal.
 */
import DistributionsScheduleModal from "./DistributionsScheduleModal";

export default DistributionsScheduleModal;
